/* import __COLOCATED_TEMPLATE__ from './task.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent-2 */

import { inject as service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import Component from '@glimmer/component';
import { type TriggeredWorkflow } from 'embercom/lib/fin-playground/question';
// @ts-expect-error
import { sanitizeHtml } from '@intercom/pulse/lib/sanitize';
import { type SafeString } from '@ember/template/-private/handlebars';

interface TaskAnswerNoticeComponentSignature {
  Args: {
    task?: TriggeredWorkflow;
  };
  Element: HTMLDivElement;
  Blocks: {
    default: [];
  };
}

export default class TaskAnswerNoticeComponent extends Component<TaskAnswerNoticeComponentSignature> {
  @service declare router: RouterService;
  @service declare appService: any;

  get taskUrl(): string {
    return this.router.urlFor(
      'apps.app.automation.fin-ai-agent.tasks.task',
      this.appService.app.id,
      this.args.task?.rulesetId,
    );
  }

  get taskName(): string {
    return this.args.task?.title ?? '';
  }

  get taskLink(): SafeString {
    return sanitizeHtml(
      `<a href="${this.taskUrl}" target="_blank" class="fin-playground__answer-notice__content__link">${this.taskName}</a>`,
    );
  }

  get taskDeleted(): boolean {
    return this.args.task?.deleted ?? true;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Playground::FinAnswer::AnswerNotice::Task': typeof TaskAnswerNoticeComponent;
    'ai-agent/playground/fin-answer/answer-notice/task': typeof TaskAnswerNoticeComponent;
  }
}
